import React, { useState, useEffect } from 'react';
import { Navigate } from 'react-router-dom';
import { paymentService } from '../services';

// Zugangs-Gating auf Basis des DB-Abo-Status (nicht mehr Clerks has({ plan })).
// Zugang, wenn subscriptionStatus ∈ {trialing, active} (hasAccess vom Backend).
// Ohne Zugang → Redirect auf die Pricing-/Upgrade-Seite.
//
// Setzt einen eingeloggten User voraus (immer innerhalb von ProtectedRoute verwenden).
const SubscriptionGate = ({ children }) => {
  const [state, setState] = useState('loading'); // 'loading' | 'granted' | 'denied'

  useEffect(() => {
    let active = true;
    paymentService
      .getSubscription()
      .then(({ data }) => { if (active) setState(data.hasAccess ? 'granted' : 'denied'); })
      .catch(() => { if (active) setState('denied'); });
    return () => { active = false; };
  }, []);

  if (state === 'loading') return null;
  if (state === 'denied') return <Navigate to="/pricing" replace />;
  return children;
};

export default SubscriptionGate;
